import { useEffect, useState } from 'react';
import DailyRewardsWeb from './index_web';
import { useLink } from 'react-router-stack';
import { isSmartPhone } from '../../utilities/helper';
import DailyRewardsMWeb from './index_mWeb';

const DailyRewards = () => {
  const navigate = useLink();

  const [scrollPage, setScrollPage] = useState(false);

  useEffect(() => {
    if (scrollPage) {
      const container = document.getElementById('dailyrewards') as HTMLDivElement;
      container.scroll({
        top: 0,
        behavior: 'smooth'
      });
      setScrollPage(false);
    }
  }, [scrollPage]);

  const onClickBack = () => {
    try {
      navigate.push('/');
    } catch (err) {
      navigate.go(-1);
    }
  };
  return (
    <>{!isSmartPhone ? <DailyRewardsWeb /> : <DailyRewardsMWeb onClickBack={onClickBack} />}</>
  );
};

export default DailyRewards;
